var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.nositem && _vm.item.stock.net <= 0 && _vm.getVarSelect
      ? _c(
          "div",
          { staticClass: "email-notice-bg mb-4 mt-1 bg-white px-3 border" },
          [
            _c("form", { attrs: { id: "sendNoticeForm" } }, [
              _c("p", { staticClass: "bold" }, [
                _vm._v(
                  "\n                Möchtest du benachrichtigt werden wenn der Artikel wieder auf Lager ist ?\n            "
                )
              ]),
              _vm._v(" "),
              _c("p"),
              _c("div", { staticClass: "input-unit" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.email,
                      expression: "email"
                    }
                  ],
                  attrs: {
                    type: "email",
                    name: "email",
                    "data-autofocus": "",
                    id: "emailForNote",
                    required: ""
                  },
                  domProps: { value: _vm.email },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.email = $event.target.value
                    }
                  }
                }),
                _vm._v(" "),
                _c("label", { attrs: { for: "emailForNote" } }, [
                  _vm._v("E-Mail*")
                ])
              ]),
              _vm._v(" "),
              _c("p"),
              _vm._v(" "),
              _c("hr"),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass:
                    "btn btn-primary btn-small btn-block send-notification",
                  on: {
                    click: function($event) {
                      return _vm.sendEmail($event)
                    }
                  }
                },
                [
                  _vm._v(
                    "\n                Benachrichtigung anfordern\n            "
                  )
                ]
              )
            ])
          ]
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }